<template>
    <div v-if="field && editor" class="container">
        <div class="control-group">
            <div class="button-group">
                <b-button @click="editor.chain().focus().toggleHeading({ level: 1 }).run()" :variant="editor.isActive('heading', { level: 1 }) ? 'dark' : 'light'">
                H1
                </b-button>
                <b-button @click="editor.chain().focus().toggleHeading({ level: 2 }).run()" :variant="editor.isActive('heading', { level: 2 }) ? 'dark' : 'light'">
                H2
                </b-button>
                <b-button @click="editor.chain().focus().toggleHeading({ level: 3 }).run()" :variant="editor.isActive('heading', { level: 3 }) ? 'dark' : 'light'">
                H3
                </b-button>
                <b-button @click="editor.chain().focus().setParagraph().run()" :variant="editor.isActive('paragraph') ? 'dark' : 'light'" >
                Paragraph
                </b-button>
                <b-button @click="editor.chain().focus().toggleBold().run()" :variant="editor.isActive('bold') ? 'dark' : 'light'" >
                Bold
                </b-button>
                <b-button @click="editor.chain().focus().toggleItalic().run()" :variant="editor.isActive('italic') ? 'dark' : 'light'" >
                Italic
                </b-button>
                <b-button @click="editor.chain().focus().toggleStrike().run()" :variant="editor.isActive('strike') ? 'dark' : 'light'" >
                Strike
                </b-button>
                <b-button @click="editor.chain().focus().toggleHighlight().run()" :variant="editor.isActive('highlight') ? 'dark' : 'light'" >
                Highlight
                </b-button>
                <b-button @click="editor.chain().focus().setTextAlign('left').run()" :variant="editor.isActive({textAlign: 'left'}) ? 'dark' : 'light'" >
                Left
                </b-button>
                <b-button @click="editor.chain().focus().setTextAlign('center').run()" :variant="editor.isActive({textAlign: 'center'}) ? 'dark' : 'light'" >
                Center
                </b-button>
                <b-button @click="editor.chain().focus().setTextAlign('right').run()" :variant="editor.isActive({textAlign: 'right'}) ? 'dark' : 'light'" >
                Right
                </b-button>
                <b-button @click="editor.chain().focus().setTextAlign('justify').run()" :variant="editor.isActive({textAlign: 'justify'}) ? 'dark' : 'light'" >
                Justify
                </b-button>
            </div>
        </div>

        <b-dropdown id="localePicker" :text="defaultLocale">
            <b-dropdown-item @click="localeEditor = true"> Edit </b-dropdown-item>
            <b-dropdown-item v-for="locale in allLocales" :key="locale" @click="currentLocale = locale">{{ locale }}</b-dropdown-item>
        </b-dropdown>

        <editor-content :editor="editor" class="editor"/>

        <b-sidebar title="Locales" right :visible="localeEditor">
            <div class="px-3 py-2">
                 <b-form-group
                    label="Locale:"
                    label-for="locale:"
                    :label-cols="3"
                    :horizontal="true">
                 <v-select multiple :options="availableLocales" v-model="allLocales"></v-select>
                </b-form-group>
            </div>
        </b-sidebar>
    </div>
</template>

<script>
import { Editor, EditorContent } from '@tiptap/vue-2';
import StarterKit from '@tiptap/starter-kit';
import Highlight from '@tiptap/extension-highlight'
import TextAlign from '@tiptap/extension-text-align'
import locales from '../locales.json'
import vSelect from 'vue-select'

export default {
    name: "IdentityField_Texti18n_Editor",
    components: {
        EditorContent,
        vSelect,
    },
    props: {
        field: {
            type: Object
        },
        value: {
            type: Object,
            default: () => {
                return {
                    locales: {}
                }
            }
        },

        store: {
            type: Object
        },
        translator: {
            type: Function
        }
    },
    data: function() {
        return {
            errors: [],
            editor: null,
            localeEditor: false,
            currentLocale: null,
            availableLocales: []
        }
    },
    computed: {
        content: {
            get() {
                try {
                    if (!this.value) {
                        this.value = Object.assign({},  {
                            locales: {
                                [this.defaultLocale]: ""
                            }
                        })
                    }

                    return this.value.locales[this.defaultLocale]
                } catch {
                    return this.value
                }
            },

            set(val) {
                let v = this.value || {
                    locales: {}
                }

                try {
                    v.locales[this.defaultLocale] = val
                } catch(err) {
                     v = {
                        locales: {}
                    }
                    
                    v.locales[this.defaultLocale] = val
                }

                this.$emit('input', v)
                this.check(v)
            }
        },

        constraints() {
            let constr = this.field.constraints

            return constr
        },

        customData() {
            let { custom_data = {} } = this.constraints || {}
            let { texti18n } = custom_data || {}

            if (texti18n) {
                return texti18n
            }

            return {
                default_locale: 'en_US'
            }
        },

        defaultLocale() {
            return this.currentLocale || this.customData.default_locale || this.storage.getters.getLocale
        },

        allLocales: {
            get() {
                try {
                    let locales = Object.keys(this.value.locales)
                    if (locales.length > 0) {
                        return locales
                    }

                    return [this.defaultLocale]
                } catch(err) {
                    return [this.defaultLocale]
                }
            },

            set(val) {
                let nVal = {}

                nVal[this.defaultLocale] = this.value.locales[this.defaultLocale]
                val.forEach(k => {
                    nVal[k] = this.value.locales[k]
                })

                this.$emit('input', {locales: nVal})
            }
        },
    },
       
    watch: {
        content(val) {
            this.check(val)
            this.editor.commands.setContent(this.content)
        }
    },

    methods: {
        check(v) {
            let value = v || this.value

            if (value) {
                Object.keys(value.locales || []).forEach(k => {
                    let val = value.locales[k] || ""

                    this.errors = []
                    this.allErrors = []

                    if (val == "" && this.constraints.required) {
                        this.errors.push(this.translator("identityField.requiredField"))
                    }
                    
                    if (this.constraints.length !== undefined) {
                        if (this.constraints.length.max !== null && this.constraints.length.max > 0) {
                            if (val.length > this.constraints.length.max && val.length > 0) {
                                this.errors.push(
                                    this.translator("identityField.cantBeMoreThenChars", {
                                        max: this.constraints.length.max
                                    })
                                )
                            }
                        }
                        
                        if (this.constraints.length.min !== null) {
                            if (val.length < this.constraints.length.min && val.length > 0) {
                                this.errors.push(
                                    this.translator("identityField.cantBeLessThenChars", {
                                        min: this.constraints.length.min
                                    })
                                )  
                            }
                        }
                    }

                    if (this.constraints.not_allowed_words !== undefined) {
                        let notAllowedWords = this.constraints.not_allowed_words.split(",")
                        notAllowedWords.forEach(word => {
                            word = word.trim()

                            if (word != "") {
                                if (val.indexOf(word) !== -1) {
                                    if (word.length < 2) {
                                        this.errors.push(
                                            this.translator("identityField.symbolNotAllowed", {
                                                symbol: word
                                            })
                                        )
                                    } else {
                                        this.errors.push(
                                            this.translator("identityField.wordNotAllowed", {
                                                word: word
                                            })
                                        )
                                    }
                                    
                                }  
                            }              
                        })
                    }

                    if (this.constraints.regex !== undefined || this.constraints.regex !== "") {
                        let re = new RegExp(this.constraints.regex)
                        if (! re.test(val)) {
                            this.errors.push(this.translator("identityField.invalidInput"))
                        }
                    }
                        
                    this.$emit("error", {field: this.field.key, error: this.errors.length > 0 || this.extendErrors.length})
                })
            }
        },
    },

    updated() {
        try {
            
            console.log("UPDATED")
        } catch {
            // do nothing
        }
    },

    mounted() {
        this.check(this.content)
        this.availableLocales = Object.keys(locales)

        this.editor = new Editor({
            extensions: [
                StarterKit,
                TextAlign.configure({
                    types: ['heading', 'paragraph']
                }),
                Highlight
            ],
            content: this.content,

            onUpdate: ({ editor }) => {
                // Emit an input event when the content changes (similar to v-model)
                //this.$emit('input', editor.getHTML());
                this.content = editor.getHTML()
            },

        });
    }
}
</script>


<style lang="scss" scoped>
.button-group > .btn {
    margin: 5px;
} 

.button-group {
    border-bottom: 1px solid #ccc;
    padding-bottom: 10px;
    padding-top: 10px;
}

.container {
    background-color: transparent;
    padding-bottom: 10px;
    border-style: solid;
    border-top: 1px solid #fff;
    border-bottom: 1px solid #fff;
    border-right: none;
    border-left: none;

    .editor {
        margin-top: 10px;
    }

    #localePicker {
        margin-top: 10px;

    }
}
</style>
